export interface ToastAction {
  readonly label: string;
  readonly onClick: () => void;
}

export interface ToastValue {
  readonly id: number;
  readonly text: string;
  readonly action?: ToastAction | undefined;
  /** Вторая кнопка: «Отменить» и «Указать срок». */
  readonly second?: ToastAction | undefined;
  /** Сколько держать на экране, мс: у «Отменить отправку» — столько, сколько можно отменить. */
  readonly duration?: number | undefined;
}

let current: ToastValue | null = null;
export const listeners = new Set<() => void>();
let seq = 0;

/** Короткое уведомление внизу экрана: «Ссылка скопирована». С действием — «Напоминание … Открыть». */
export function toast(text: string, options: { readonly action?: ToastAction; readonly second?: ToastAction; readonly duration?: number } = {}): void {
  current = { id: ++seq, text, action: options.action, second: options.second, duration: options.duration };
  listeners.forEach((l) => {
    l();
  });
}

export function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function currentToast(): ToastValue | null {
  return current;
}

export function clearToast(id: number): void {
  if (current?.id === id) {
    current = null;
    listeners.forEach((l) => {
      l();
    });
  }
}
